import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { TradingPage } from './pages/TradingPage';
import { HomePage } from './pages/HomePage';
import { HistoryPage } from './pages/HistoryPage';
import { PortfolioPage } from './pages/PortfolioPage';
import { MarketsPage } from './pages/MarketsPage';
import { AnalyticsPage } from './pages/AnalyticsPage';
export function App() {
  return <Router data-id="element-0">
      <Routes data-id="element-1">
        <Route path="/" element={<HomePage data-id="element-3" />} data-id="element-2" />
        <Route path="/trade" element={<TradingPage data-id="element-5" />} data-id="element-4" />
        <Route path="/markets" element={<MarketsPage data-id="element-7" />} data-id="element-6" />
        <Route path="/portfolio" element={<PortfolioPage data-id="element-9" />} data-id="element-8" />
        <Route path="/history" element={<HistoryPage data-id="element-11" />} data-id="element-10" />
        <Route path="/analytics" element={<AnalyticsPage data-id="element-13" />} data-id="element-12" />
        <Route path="*" element={<Navigate to="/" replace data-id="element-15" />} data-id="element-14" />
      </Routes>
    </Router>;
}